import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import {
	ParamsDocumentsIds,
	ParamsDocumentsWithoutIdDocument,
	ParamsDocumentsWithoutNameGroup,
	RegistratorCabinetDocument,
} from 'Pages/registratorCabinet'

export const documentsApi = {
	loadDocumentRbidosRequest: async (params: ParamsDocumentsWithoutIdDocument) => {
		const data = new FormData()
		data.append('[data][file]', params.file as string)
		const res = await axiosDS().post<Promise<RegistratorCabinetDocument>>(
			`${urls.cabinet.rbidosRequest}/${params.id}/document/${params.nameGroup}`,
			data
		)
		return res.data
	},
	deleteDocumentRbidosRequest: async (params: ParamsDocumentsIds) => {
		const res = await axiosDS().delete(
			`${urls.cabinet.rbidosRequest}/${params.id}/document/${params.idDocument}`
		)
		return res.data
	},
	updateDocumentRbidosCustomer: async (params: ParamsDocumentsWithoutNameGroup) => {
		const data = new FormData()
		data.append('[data][file]', params.file as string)
		const res = await axiosDS().patch<Promise<RegistratorCabinetDocument>>(
			`${urls.cabinet.rbidosCustomer}/${params.id}/customer_identification_document/${params.idDocument}`,
			data
		)
		return res.data
	},
	deleteDocumentRbidosCustomer: async (params: ParamsDocumentsIds) => {
		const res = await axiosDS().delete(
			`${urls.cabinet.rbidosCustomer}/${params.id}/customer_identification_document/${params.idDocument}`
		)
		return res.data
	},
	downloadAllDocuments: async (id: number) => {
		const res = await axiosDS().get<Blob>(
			urls.cabinet.download_all_documents.replace(':id', id.toString()),
			{
				responseType: 'blob',
			}
		)
		return res.data
	},
}
